module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedMedium.5ca2042.eot";